import { HttpInterceptor, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent,
  HttpResponse, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SharedService } from '../common/shared.service';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  shared: SharedService;

  constructor() {
    this.shared = SharedService.getInstance();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.shared = SharedService.getInstance();
    let authRequest: any;
    if (this.shared.isLoggedIn()) {
      if(this.shared.unidade){
        authRequest = req.clone({
          setHeaders: {
            // foi colocado Bearer por causa do json server, tirar caso autenticação em outra api
            'Authorization' : this.shared.token,
            'UNIDADE' : `${this.shared.unidade.id}`,
            'SISTEMA' : 'FOLPAG',
            'ENTIDADE' : `${this.shared.usuario.entidade.id}`,
          }
        });
      } else {
        authRequest = req.clone({
          setHeaders: {
            // foi colocado Bearer por causa do json server, tirar caso autenticação em outra api
            'Authorization' : this.shared.token,
            'ENTIDADE' : `${this.shared.usuario.entidade.id}`,
            'SISTEMA' : `FOLPAG`,
          }
        });
      }
      return next.handle(authRequest);
    } else {
      authRequest = req.clone({
        setHeaders: {
          'SISTEMA' : `FOLPAG`,
        }
      });
      return next.handle(authRequest);
    }
  }
}
